const expandCategoryPath = categoryPath => {
  return categoryPath
    .split('/')
    .filter(Boolean)
    .reduce((acc, slug) => {
      const pathPrefix = acc[acc.length - 1] ?? '';
      const nextPath = `${pathPrefix}/${slug}`;

      acc.push(nextPath);

      return acc;
    }, []);
};

export { expandCategoryPath };
